<template><section><h2>基础气泡图</h2>
<block-demo tip="" source="const data = [
  {
    x: 95,
    y: 95,
    z: 13.8,
    name: &#39;BE&#39;,
    country: &#39;Belgium&#39;
  },
  {
    x: 86.5,
    y: 102.9,
    z: 14.7,
    name: &#39;DE&#39;,
    country: &#39;Germany&#39;
  },
  {
    x: 80.8,
    y: 91.5,
    z: 15.8,
    name: &#39;FI&#39;,
    country: &#39;Finland&#39;
  },
  {
    x: 80.4,
    y: 102.5,
    z: 12,
    name: &#39;NL&#39;,
    country: &#39;Netherlands&#39;
  },
  {
    x: 80.3,
    y: 86.1,
    z: 11.8,
    name: &#39;SE&#39;,
    country: &#39;Sweden&#39;
  },
  {
    x: 78.4,
    y: 70.1,
    z: 16.6,
    name: &#39;ES&#39;,
    country: &#39;Spain&#39;
  },
  {
    x: 74.2,
    y: 68.5,
    z: 14.5,
    name: &#39;FR&#39;,
    country: &#39;France&#39;
  },
  {
    x: 73.5,
    y: 83.1,
    z: 10,
    name: &#39;NO&#39;,
    country: &#39;Norway&#39;
  },
  {
    x: 71,
    y: 93.2,
    z: 24.7,
    name: &#39;UK&#39;,
    country: &#39;United Kingdom&#39;
  },
  {
    x: 69.2,
    y: 57.6,
    z: 10.4,
    name: &#39;IT&#39;,
    country: &#39;Italy&#39;
  },
  {
    x: 68.6,
    y: 20,
    z: 16,
    name: &#39;RU&#39;,
    country: &#39;Russia&#39;
  },
  {
    x: 65.5,
    y: 126.4,
    z: 35.3,
    name: &#39;US&#39;,
    country: &#39;United States&#39;
  },
  {
    x: 65.4,
    y: 50.8,
    z: 28.5,
    name: &#39;HU&#39;,
    country: &#39;Hungary&#39;
  },
  {
    x: 63.4,
    y: 51.8,
    z: 15.4,
    name: &#39;PT&#39;,
    country: &#39;Portugal&#39;
  },
  {
    x: 64,
    y: 82.9,
    z: 31.3,
    name: &#39;NZ&#39;,
    country: &#39;New Zealand&#39;
  }
]
data.sort((a, b) =&gt; a.height - b.height)
const { Chart, Axis, Scatter, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  text: &#39;x&#39;,
  value: &#39;y&#39;
})
const scatter = new Scatter({
  areaField: &#39;z&#39;,
  labelField: &#39;name&#39;
})

const axisBottom = new Axis()

const axisLeft = new Axis({ orient: &#39;left&#39; })

const tooltip = new Tooltip({
  formatter: data =&gt; {
    return `${data.name}: ${data.y}`
  }
})

chart.append([scatter, tooltip, axisBottom, axisLeft])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">95</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">95</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">13.8</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'BE'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Belgium'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">86.5</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">102.9</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">14.7</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'DE'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Germany'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">80.8</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">91.5</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">15.8</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'FI'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Finland'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">80.4</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">102.5</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">12</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'NL'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Netherlands'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">80.3</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">86.1</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">11.8</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'SE'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Sweden'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">78.4</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">70.1</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">16.6</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'ES'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Spain'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">74.2</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">68.5</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">14.5</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'FR'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'France'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">73.5</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">83.1</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">10</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'NO'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Norway'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">71</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">93.2</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">24.7</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'UK'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'United Kingdom'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">69.2</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">57.6</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">10.4</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'IT'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Italy'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">68.6</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">20</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">16</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'RU'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Russia'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">65.5</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">126.4</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">35.3</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'US'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'United States'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">65.4</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">50.8</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">28.5</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'HU'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Hungary'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">63.4</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">51.8</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">15.4</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'PT'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'Portugal'</span>
  },
  {
    <span class="hljs-attr">x</span>: <span class="hljs-number">64</span>,
    <span class="hljs-attr">y</span>: <span class="hljs-number">82.9</span>,
    <span class="hljs-attr">z</span>: <span class="hljs-number">31.3</span>,
    <span class="hljs-attr">name</span>: <span class="hljs-string">'NZ'</span>,
    <span class="hljs-attr">country</span>: <span class="hljs-string">'New Zealand'</span>
  }
]
data.sort(<span class="hljs-function">(<span class="hljs-params">a, b</span>) =&gt;</span> a.height - b.height)
<span class="hljs-keyword">const</span> { Chart, Axis, Scatter, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">text</span>: <span class="hljs-string">'x'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'y'</span>
})
<span class="hljs-keyword">const</span> scatter = <span class="hljs-keyword">new</span> Scatter({
  <span class="hljs-attr">areaField</span>: <span class="hljs-string">'z'</span>,
  <span class="hljs-attr">labelField</span>: <span class="hljs-string">'name'</span>
})

<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis()

<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> })

<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip({
  <span class="hljs-attr">formatter</span>: <span class="hljs-function"><span class="hljs-params">data</span> =&gt;</span> {
    <span class="hljs-keyword">return</span> <span class="hljs-string">`<span class="hljs-subst">${data.name}</span>: <span class="hljs-subst">${data.y}</span>`</span>
  }
})

chart.append([scatter, tooltip, axisBottom, axisLeft])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>